import api from 'Application/api/api';

const setImageDescription = (signal, description, imageName, projectId) =>
	api.put(`/images/set-description/${projectId}?description=${description}&imageName=${imageName}`, {
		signal,
	});

export default setImageDescription;
